import { cmdPaymentWindowIconClick } from '../../general/modules/webAppFunctions';

export class PaymentWindowIconClickHandler {
    public handle(): void {
        cmdPaymentWindowIconClick();
    }
}
